import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import Layout from '../../../layouts'
import LargeHero from '../../../components/elements/largeHero'
import { Body, Canon, SizedText } from '../../../components/elements/typography'
import Grid from '../../../components/elements/grid'

import Icon from '../../../components/elements/icon'
import rightArrowIcon from '../../../theme/icons/right-arrow.svg'

const SwipeNSavePage = () => {
  return (
    <Layout isSubMenuOpen={false} openAccountLink={true}>
            { /* ------ * HERO SECTION * ------ */}
      <LargeHero.Container
        background={{
          //https://www.svgeez.com/projects/mod-dots-repeating-background-svg
          backgroundColor:`rgb(148, 197, 227)`,
          fill:`rgba(94, 166, 209, 0.1)`,
          backgroundSize:`369px 369px`,
          backgroundRepeat:`repeat`,
          backgroundImage:`url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500' fill-opacity='1' style='enable-background:new 0 0 500 500'%3E%3Cstyle%3E .st2{fill:rgba(94, 166, 209, 0.15)} %3C/style%3E%3Cg style='display:none'%3E%3Cpath style='display:inline;fill:%236D6E71' d='M-64.9-73.9h675v675h-675z' id='Layer_2'/%3E%3C/g%3E%3Cg id='Layer_1'%3E%3Ccircle class='st2' cx='417.4' cy='83.7' r='82.8'/%3E%3Cpath class='st2' d='M78.1 82.7C78.1 38.2 43.1 2-.8 0v165.3c43.9-2 78.9-38.2 78.9-82.6zM87.9 82.7c0 44.4 35 80.7 78.9 82.7V0c-43.9 2-78.9 38.2-78.9 82.7zM167.2 167.3v165.3c43.9-2 78.9-38.2 78.9-82.7s-34.9-80.6-78.9-82.6zM332.8 332.7V167.3c-43.9 2-78.9 38.2-78.9 82.7s34.9 80.7 78.9 82.7zM417.3 253.7c-44.4 0-80.7 35-82.7 78.9H500c-2-43.9-38.2-78.9-82.7-78.9zM417.3 246.5c44.4 0 80.7-35 82.7-78.9H334.7c2 43.9 38.2 78.9 82.6 78.9zM84 421.1c-44.4 0-80.7 35-82.7 78.9h165.3c-2-43.9-38.2-78.9-82.6-78.9zM84 413.4c44.4 0 80.7-35 82.7-78.9H1.3c2 43.9 38.2 78.9 82.7 78.9zM250.1 78.9c44.4 0 80.7-35 82.7-78.9H167.4c2 43.9 38.3 78.9 82.7 78.9zM250.1 87.5c-44.4 0-80.7 35-82.7 78.9h165.3c-1.9-43.9-38.2-78.9-82.6-78.9z'/%3E%3Ccircle class='st2' cx='84.1' cy='250.1' r='82.8'/%3E%3Cpath class='st2' d='M167.2 334.5v165.3c43.9-2 78.9-38.2 78.9-82.7s-34.9-80.6-78.9-82.6zM421.9 417.2c0 44.4 35 80.7 78.9 82.7V334.6c-43.9 1.9-78.9 38.2-78.9 82.6z'/%3E%3Ccircle class='st2' cx='333.2' cy='417.3' r='82.8'/%3E%3C/g%3E%3C/svg%3E");`,
        }}
      >
        <LargeHero.Content styles={{ background: `radial-gradient(circle, rgba(148, 197, 227, 0.5) 40%, rgba(148, 197, 227, 0) 100%)`}}>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1`, padding: `0.25rem 0`}}}>
            <SizedText as="span" smallSize="1.602" largeSize="2.887">Save every time you spend with</SizedText>
            <SizedText as="span" smallSize="2.887" largeSize="5.852">TCB Swipe-N-Save</SizedText>
            <span css={{fontFamily: `source-sans-pro`, fontWeight: `300`, textTransform: `capitalize`, fontSize: `2.027rem`}}>Optional Automatic Round-Up Savings Program</span>
          </h1>
        </LargeHero.Content>
        <LargeHero.Image>
          <StaticImage src="../images/products/swipe-n-save/tcb_swipe-n-save_debit-card.png" alt="TCB Debit Card with Piggy Bank"/>
        </LargeHero.Image>
      </LargeHero.Container>
      
      <Grid.FullWidthSection as="section" css={{padding: `6rem 0`}}>
        <Grid.Block start={['2']} span={['12']} css={{textAlign: `center`, paddingBottom: `2rem`}}>
          <Canon>A Little Change Can Go A Long Way!</Canon>
        </Grid.Block>
        <Grid.Block start={['2', '2', '2', '2','2', '3']} span={['12', '12', '12', '12', '5', '4']}>
          <div css={{textAlign: `center`}}>
            <StaticImage src="../../../images/products/swipe-n-save/tcb-swipe-n-save-transactions.png" alt='TCB Swipe-N-Save automatic round up savings.' />
          </div>
          <div css={{padding: `2rem 0`}}>
          <Link 
              to="/resources/forms/swipensave-automatic-roundup-savings-application" 
              css={{
                display: `inline-block`,
                width: `100%`,
                padding: `0.75rem 2rem`,
                backgroundColor: `#2ecc71`,
                borderRadius: `0.5rem`,
                color: `#fff !important`,
                textDecoration: `none`,
                border: `1px solid #27ae60`,
                textAlign: `center`
              }}
            >
                <span>Sign Up For TCB SwipeNSave Online Now</span>
                <span css={{paddingLeft: `0.75rem`}}><Icon icon={rightArrowIcon} overrides={{verticalAlign: `-0.25rem !important`}}/></span>
            </Link>
          </div>
        </Grid.Block>
        <Grid.Block start={['2', '2', '2', '2','7', '7']} span={['12', '12', '12', '12', '7', '6']} css={{ 'h2': { marginTop: `2rem`, color: `#3498db`, fontFamily: `proxima-nova`} }}>  
            <Body>
              TCB’s optional SwipeNSave program makes it easy to save every day by automatically rounding up each purchase you make with your TCB MasterCard Debit Card to the nearest whole dollar and
              depositing that amount in your linked savings account. The more you use your TCB Debit Card, the more you save. If you make multiple qualifying transactions in one day, the total amount 
              that rounds up for each transaction is added up and transferred as one lump sum at the end of the day. Rounding only happens after an item has hard posted. Items that are still pending 
              will not show a rounded amount.  
            </Body>
            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Linked Accounts
            </SizedText>
            <Body>
              SwipeNSave is configured on your checking account, so each checking account can only be linked to one savings account at a time.  You can, however, have multiple checking accounts link to a 
              single savings account at a time. <br /><br />
            </Body>
            <h3>So for example:</h3>
            <Body>
              If you have two children, <span css={{color: `#c0392b`, textDecoration: `underline`}}><b>YOU CAN NOT HAVE</b></span> SwipeNSave round up and deposit funds equally into both of your children's savings accounts.  Each checking account with TCB SwipeNSave can only be linked to one 
              savings account at a time.<br /><br />
              
              If you and your partner have your own checking accounts, <span css={{color: `#27ae60`, textDecoration: `underline`}}><b>YOU CAN HAVE</b></span> both of those accounts round-up into a single joint savings account that you share.  Because SwipeNSave is set up on the checking account, 
              you can have as many checking accounts that you want to deposit into the same savings account.
            </Body>
            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Joint Accounts
            </SizedText>
            <Body>
              Because TCB SwipeNSave is configured on your checking account, <b css={{textDecoration: `underline`}}>all</b> debit card purchases made on that account will be rounded up.  This means that if you and your partner have a joint account, and you each have your own debit card,
              SwipeNSave will round up purchases made with both cards.  There is no way to turn SwipeNSave on for just one debit card on a joint account.  
            </Body>
            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Introductory Promotion
            </SizedText>
            <Body>
              If you sign up for SwipeNSave, TCB will match 100% of your rounded-up savings dollar for dollar for the first 90 days up to $100.  
            </Body>
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout>
  )
}

export default SwipeNSavePage